<template>
  <span>
    <v-text-field v-model="color" v-mask="mask" :label="label" hide-details solo flat>
      <template v-slot:prepend>
        <v-menu v-model="menu" top nudge-bottom="205" nudge-left="16" :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <div :style="swatchStyle" v-on="on" />
          </template>
          <v-card>
            <v-card-text class="pa-0">
              <v-color-picker v-model="color" hide-inputs flat />
            </v-card-text>
          </v-card>
        </v-menu>
      </template>
    </v-text-field>
  </span>
</template>

<script>
import ATInputMixin from "./ATInputMixin.js";

export default {
  mixins: [ATInputMixin],
  mounted() {
    this.color = this.text;
  },
  data() {
    return {
      color: null,
      mask: '!#XXXXXX',
      menu: false,
    };
  },
  watch: {
    text() {
      this.$log.debug(this.text)
      this.color = this.text;
    },
    menu() {
      this.$log.debug(this.menu)
      this.$log.debug(this.color)
      if (this.menu == false) {
        this.changed(this.color)
      }
    }
  },
  computed: {
    swatchStyle() {
      const { color, menu } = this
      return {
        backgroundColor: color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    }
  },
};
</script>